// extracted by mini-css-extract-plugin
module.exports = {"rec__item":"style-module--rec__item--2CizI","rec__icon":"style-module--rec__icon--2eqiv"};